<div class="publication-card grid bg-grayscale-white mb-half">
    <div class="publication-card__image grid-12 grid-md-6">
        <img class="image img-responsive" src="../../../assets/images/products/inmueble-test.png" alt="foto inmueble">
    </div>
    <div class="publication-card__description grid-12 grid-md-6">
        <h2 class="main-title d-flex ai-center text-base text-primary-base mt-none">Casa El Porvenir Bogotá
            <button class="icon-share text-mid text-primary-base pl-tiny" type="button" aria-label="share button"></button>
        </h2>
        <div class="grid grid-gap-0">
            <div class="grid-12">
                <span class="label-title text-grayscale-gray-5 text-xsmall">Valor de venta:</span>
                <h3 class="secondary-title m-none text-half text-secondary-base">$1200.000.000</h3>
            </div>
            <div class="grid-6">
                <span class="label-title text-grayscale-gray-5 text-xsmall">Código:</span>
                <h4 class="secondary-title m-none text-small">7060-15827839</h4>
            </div>
            <div class="grid-6">
                <span class="label-title text-grayscale-gray-5 text-xsmall">Fecha de ingreso:</span>
                <h4 class="secondary-title m-none text-small"><time datetime="2020-05-18">May / 18 / 2020</time></h4>
            </div>
            <div class="grid-12">
                <span class="label-title text-grayscale-gray-5 text-xsmall">Dirección:</span>
                <h4 class="secondary-title m-none text-small">Calle 49 Sur # 98 - 105 / El Porvenir</h4>
            </div>
            
        </div>
        <ul class="d-flex jc-space-between mt-mid text-xsmall">
            <li class="text-complementary-two"><span class="text-small pr-tiny icon-habitacionprincipal"></span>5 Hab</li>
            <li class="text-complementary-two"><span class="text-small pr-tiny icon-bano_c"></span>3 Baños</li>
            <li class="text-complementary-two"><span class="text-small pr-tiny icon-carro"></span>1 Pq</li>
            <li class="text-complementary-two"><span class="text-small pr-tiny icon-meters"></span>75 m<sup>2</sup></li>
        </ul>
    </div>
    <div class="publication-card__options grid-12 bg-primary-base-9 p-base">
        <h2 class="m-none text-small text-primary-dark">MIS PRODUCTOS:</h2>
        <div class="d-lg-flex jc-space-between">
            <mat-checkbox class="mat-checkbox--white text-small mt-tiny d-block" [(ngModel)]="checked">
                <button mat-button [matMenuTriggerFor]="aboveMenu" class="mat-menu-trigger--transparent" aria-label="button trigger tooltip"></button>
                Destacar inmueble</mat-checkbox>
            <mat-checkbox class="mat-checkbox--white text-small mt-tiny d-block">Ascender inmueble</mat-checkbox>
            <div class="panel-footer mt-tiny d-flex">
                <button class="button secondary rounded text-xsmall px-mid py-tiny mr-base" type="button" (click)="openAppointmentDialog()">fotos 360</button>
                <button class="button primary rounded text-xsmall px-mid py-tiny" type="button" (click)="openAppointmentDialog()">recorrido 3d</button>
            </div>
        </div>
        <mat-menu #aboveMenu="matMenu" yPosition="above" class="p-thumb text-center mat-menu--tooltip">
            <h2 class="text-secondary-base text-xsmall">¿Estás seguro de destacar este inmueble?</h2>
            <p class="text-xsmall">Una vez destacado, no podrás deshacer está opción.</p>
            <div class="d-flex jc-space-evenly mt-base">
                <button class="button rounded secondary p-tiny text-xsmall" (click)="highlightChecked()" type="button">ASCENDER</button>
                <button class="button outline rounded secondary p-tiny text-xsmall" type="button">CANCELAR</button>
            </div>
        </mat-menu>
    </div>
    <div class="publication-card__settings grid grid-12">
        <button class="grid-12 grid-md-6 button secondary outline rounded text-small py-tiny block" type="button">Desactivar</button>
        <div class="grid-12 grid-md-6 d-flex ai-center jc-space-evenly">
            <div class="panel-footer d-flex">
                <button class="btn-transparent ai-center d-inline-flex text-primary-base text-small" type="button"><span class="icon icon-pencil pr-tiny text-half"></span>Editar</button>
                <button class="btn-transparent ai-center d-inline-flex text-primary-base text-small ml-thumb" type="button"><span class="icon icon-remove pr-tiny text-half"></span>Eliminar</button>
            </div>
            <button class="icon-share text-mid text-primary-base" type="button" aria-label="share button"></button>
        </div>
    </div>
</div>